/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
// import requestRawDev from '@/utils/requestRawDev'
// import requestDev from '@/utils/requestDev'
import { APIReportPHP, APICore } from '@/utils/servicesApi'
const qs = require('qs')
export function tourDetail(param) {
    return requestRaw({
        url: APICore() + '/tour/detail',
        method: 'POST',
        data: param
    })
}
export function tourComplete(param) {
    return requestRaw({
        url: APICore() + '/tour/complete',
        method: 'POST',
        data: param
    })
}
export function updateHasTourIntroduction() {
    return requestRaw({
        url: APICore() + '/tour/update_has_tour_introduction',
        method: 'POST',
    })
}


// WEBPACK FOOTER //
// ./src/api/tour.js